// The products window below the bean hero: grows to fill the screen as it scrolls in, slides the
// cards up in turn, types its heading, and wafts braille steam either side of its title bar. All the look lives in okayok-terminal.css; this only
// tells it how far in the window is (--okt-p, 0..1).
// The title bar from the brew page: steam · okayok coffee · steam. Each side fills its half with
// braille steam wafting up toward the title; it only animates while isOnScreen() says so.
// With home set, the title is instead a "GoHome" link to the home page, led by a little ASCII
// rocket doing barrel rolls (its fin turns | / - \ and its exhaust flickers).
function oktTitleBar(isOnScreen, { home = false } = {}) {
  const still = matchMedia("(prefers-reduced-motion: reduce)");
  const bar = document.createElement("div");
  bar.className = "okt-bar";
  const steamL = document.createElement("div");
  const steamR = document.createElement("div");
  const logo = document.createElement(home ? "a" : "div");
  steamL.className = "okt-steam";
  steamR.className = "okt-steam r";
  logo.className = "okt-logo";
  let rocket = null;
  if (home) {
    logo.href = "/";
    logo.classList.add("okt-gohome");
    rocket = document.createElement("span");
    rocket.className = "okt-rocket";
    rocket.setAttribute("aria-hidden", "true");
    logo.append(rocket, " GoHome");
    steamL.setAttribute("aria-hidden", "true");
    steamR.setAttribute("aria-hidden", "true");
  } else {
    logo.textContent = "okayok coffee";
    bar.setAttribute("aria-hidden", "true"); // decoration; the header already names the shop
  }
  bar.append(steamL, logo, steamR);

  // Each braille column carries one wisp rising through its 4-dot cell, at its own pace.
  const DOTS = [[0x01, 0x08], [0x02, 0x10], [0x04, 0x20], [0x40, 0x80]];
  function steam(frame, mirror, n) {
    let out = "";
    for (let c = 0; c < n; c++) {
      let bits = 0;
      for (let side = 0; side < 2; side++) {
        const col = c * 2 + side;
        const speed = 1 + ((col * 7) % 3);
        const row = 3 - (Math.floor(frame / speed) + col * 5) % 6;
        if (row >= 0 && row < 4 && (col + Math.floor(frame / 9)) % 3 !== 0) bits |= DOTS[row][mirror ? 1 - side : side];
      }
      out += String.fromCharCode(0x2800 + bits);
    }
    return mirror ? [...out].reverse().join("") : out;
  }
  // How many braille cells fit beside the title; the right side is the left mirrored.
  let frame = 0, cells = 8;
  const measure = document.createElement("canvas").getContext("2d");
  function fitSteam() {
    measure.font = getComputedStyle(steamL).font;
    const cw = measure.measureText("⣿").width || 8;
    cells = Math.max(4, Math.min(120, Math.floor(steamL.clientWidth / cw)));
    paintSteam();
  }
  const FIN = "|/-\\", FLAME = "~-=-";
  function paintSteam() {
    steamL.textContent = steam(frame, false, cells);
    steamR.textContent = steam(frame, true, cells);
    if (rocket) rocket.textContent = `<${FIN[frame % 4]}]=${FLAME[(frame >> 1) % 4]}`;
  }
  requestAnimationFrame(fitSteam); // once it's in the page and has a width
  try { new ResizeObserver(fitSteam).observe(steamL); } catch { addEventListener("resize", fitSteam); }
  document.fonts?.ready.then(fitSteam);
  setInterval(() => {
    if (!isOnScreen() || still.matches || document.hidden) return;
    frame++;
    paintSteam();
  }, 140);
  return bar;
}

(() => {
  const hero = document.querySelector("main > .hero-wrapper");
  const stage = hero?.nextElementSibling;
  if (!stage?.classList.contains("shopify-section")) return;
  stage.classList.add("okt-stage");
  const still = matchMedia("(prefers-reduced-motion: reduce)");

  // ---- title bar: steam · okayok coffee · steam (the brew page's header) ----
  let onScreen = false;
  const section = stage.querySelector(":scope > .section");
  (section || stage).prepend(oktTitleBar(() => onScreen));

  stage.querySelectorAll(".resource-list__item").forEach((el, i) => el.style.setProperty("--okt-i", i));

  // The heading: blanked to a cursor now, typed out once the window is mostly open.
  const heading = stage.querySelector(".section-resource-list__header :is(h1, h2, h3, h4, h5, h6)");
  const words = heading?.textContent.trim() || "";
  const typed = document.createElement("span");
  const cursor = document.createElement("span");
  cursor.className = "okt-cursor";
  cursor.setAttribute("aria-hidden", "true");
  cursor.textContent = "▌";
  let state = "waiting";
  if (heading && words) {
    heading.setAttribute("aria-label", words);
    heading.style.minWidth = `${words.length + 1}ch`; // its full width up front, so nothing beside it shifts as it types
    const line = document.createElement("span");
    line.append(typed, cursor);
    heading.replaceChildren(line);
    if (still.matches) { typed.textContent = words; state = "done"; }
  }
  function type() {
    state = "typing";
    let n = 0;
    const timer = setInterval(() => {
      typed.textContent = words.slice(0, ++n);
      if (n >= words.length) { clearInterval(timer); state = "done"; }
    }, 75);
  }

  let queued = false;
  function update() {
    queued = false;
    const top = stage.getBoundingClientRect().top;
    const p = still.matches ? 1 : Math.min(1, Math.max(0, 1 - top / innerHeight));
    stage.style.setProperty("--okt-p", p.toFixed(4));
    const rect = stage.getBoundingClientRect();
    onScreen = rect.top < innerHeight && rect.bottom > 0;
    if (state === "waiting" && words && p > 0.6) type();
  }
  const soon = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
  addEventListener("scroll", soon, { passive: true });
  addEventListener("resize", soon);
  update();
})();

// The About panel's spinning ASCII bean (from the brew page): an ellipsoid, flatter on the creased
// face, with an S-shaped crease, sampled like donut.c (rotate, project, z-buffer, shade by light).
(() => {
  const els = document.querySelectorAll("[data-okt-bean]");
  if (!els.length) return;
  const still = matchMedia("(prefers-reduced-motion: reduce)");
  const BW = 28, BH = 15, SHADE = ".,-~:;=!*#$@";
  const TWINKLE = ".+*+."; // a hover sparkle's life, one character per few frames
  function beanFrame(spin, sparkles) {
    const lum = new Array(BW * BH).fill(null);
    const zbuf = new Float32Array(BW * BH);
    const tilt = 0.22, cT = Math.cos(tilt), sT = Math.sin(tilt);
    const cA = Math.cos(spin), sA = Math.sin(spin);
    const L = [-0.35, 0.55, 0.76]; // light from upper left, toward the viewer
    for (let th = 0; th < 2 * Math.PI; th += 0.035) {
      for (let ph = -Math.PI / 2; ph <= Math.PI / 2; ph += 0.035) {
        const ux = Math.cos(ph) * Math.cos(th), uy = Math.sin(ph), uz = Math.cos(ph) * Math.sin(th);
        const a = 0.74, b = 1, c = uz > 0 ? 0.44 : 0.58; // radii: width, length, depth (front is flatter)
        let x = a * ux, y = b * uy, z = c * uz;
        let nx = x / (a * a), ny = y / (b * b), nz = z / (c * c);
        const nl = Math.hypot(nx, ny, nz); nx /= nl; ny /= nl; nz /= nl;
        // the crease: an S down the middle of the flat face
        const crease = uz > 0.35 && Math.abs(x - 0.14 * Math.sin(2.6 * y)) < 0.105 && Math.abs(y) < 0.84;
        if (crease) z -= 0.08;
        // spin about the long axis, then tip toward the viewer
        const x1 = x * cA + z * sA, z1 = -x * sA + z * cA;
        const y2 = y * cT - z1 * sT, z2 = y * sT + z1 * cT;
        const nx1 = nx * cA + nz * sA, nz1 = -nx * sA + nz * cA;
        const ny2 = ny * cT - nz1 * sT, nz2 = ny * sT + nz1 * cT;
        const ooz = 1 / (3.2 - z2);
        const px = Math.round(BW / 2 + 1.65 * 19 * ooz * x1); // a character cell is ~0.6 as wide as tall
        const py = Math.round(BH / 2 - 19 * ooz * y2);
        if (px < 0 || px >= BW || py < 0 || py >= BH) continue;
        const i = py * BW + px;
        if (ooz <= zbuf[i]) continue;
        zbuf[i] = ooz;
        lum[i] = crease ? -1 : nx1 * L[0] + ny2 * L[1] + nz2 * L[2];
      }
    }
    let html = "", run = "", cls = "";
    const flush = () => { if (run) html += cls ? `<span class="${cls}">${run}</span>` : run; run = ""; };
    for (let r = 0; r < BH; r++) {
      for (let col = 0; col < BW; col++) {
        const v = lum[r * BW + col];
        let ch = " ", k = "";
        const sp = v === null && sparkles && sparkles.get(r * BW + col);
        if (sp !== undefined && sp !== false) { ch = TWINKLE[Math.min(TWINKLE.length - 1, sp >> 1)]; k = "s"; }
        else if (v === -1) { ch = "."; k = "c"; }
        else if (v !== null) {
          ch = SHADE[Math.max(0, Math.min(SHADE.length - 1, Math.floor((v + 0.15) * 9.5)))];
          k = v > 0.55 ? "h" : v > 0.15 ? "m" : "l";
        }
        if (k !== cls) { flush(); cls = k; }
        run += ch;
      }
      flush();
      if (r < BH - 1) html += "\n";
    }
    return html;
  }
  // Only spin while a bean is on screen.
  const seen = new Set();
  try {
    const io = new IntersectionObserver((es) => es.forEach((e) => e.isIntersecting ? seen.add(e.target) : seen.delete(e.target)));
    els.forEach((el) => io.observe(el));
  } catch { els.forEach((el) => seen.add(el)); }
  // Hovering turns the bean rainbow (CSS) and sprinkles twinkling stars around it: cell -> age.
  // Phones can't hover, so a tap plays the same for a couple of seconds (.okt-tapped).
  const sparkles = new Map();
  els.forEach((el) => {
    let tap = 0;
    // (Redrawing the bean under the pointer re-fires pointerenter every frame, so keep the stars going.)
    el.addEventListener("pointerenter", () => { if (!sparkles.has(el)) sparkles.set(el, new Map()); });
    el.addEventListener("pointerleave", (e) => { if (e.pointerType !== "touch") sparkles.delete(el); });
    el.addEventListener("pointerup", (e) => {
      if (e.pointerType !== "touch") return;
      if (!sparkles.has(el)) sparkles.set(el, new Map());
      el.classList.add("okt-tapped");
      clearTimeout(tap);
      tap = setTimeout(() => { el.classList.remove("okt-tapped"); sparkles.delete(el); }, 2000);
    });
  });
  function twinkle(sp) {
    sp.forEach((age, i) => (age >= TWINKLE.length * 2 - 1 ? sp.delete(i) : sp.set(i, age + 1)));
    for (let n = 0; n < 2; n++) if (Math.random() < 0.6) sp.set(Math.floor(Math.random() * BW * BH), 0);
  }
  let spin = 0.6;
  const draw = (el) => { el.innerHTML = beanFrame(spin, sparkles.get(el)); }; // built only from the fixed characters above
  els.forEach(draw);
  setInterval(() => {
    if (document.hidden || still.matches || !seen.size) return;
    spin += 0.11;
    sparkles.forEach(twinkle);
    seen.forEach(draw);
  }, 70);
})();

// The About heading's shooting star: hovering drops twinkling stars around it, like the bean.
// A tap on a phone does the same for a couple of seconds (.okt-tapped).
(() => {
  const still = matchMedia("(prefers-reduced-motion: reduce)");
  document.querySelectorAll("[data-okt-sparkle]").forEach((el) => {
    let timer = 0, tap = 0;
    const spawn = () => {
      const s = document.createElement("span");
      s.className = "okt-twinkle";
      s.textContent = "+*.'"[Math.floor(Math.random() * 4)];
      s.style.left = `${-10 + Math.random() * 120}%`;
      s.style.top = `${-40 + Math.random() * 180}%`;
      s.addEventListener("animationend", () => s.remove());
      el.append(s);
    };
    const start = () => {
      if (still.matches || timer) return;
      spawn();
      timer = setInterval(spawn, 110);
    };
    const stop = () => { clearInterval(timer); timer = 0; };
    el.addEventListener("pointerenter", (e) => { if (e.pointerType !== "touch") start(); });
    el.addEventListener("pointerleave", (e) => { if (e.pointerType !== "touch") stop(); });
    el.addEventListener("pointerup", (e) => {
      if (e.pointerType !== "touch") return;
      start();
      el.classList.add("okt-tapped");
      clearTimeout(tap);
      tap = setTimeout(() => { el.classList.remove("okt-tapped"); stop(); }, 2000);
    });
  });
})();

// A "scroll ↓" hint at the foot of the bean hero: there's no menu, so this is the clue that the
// coffee is further down. It bobs gently, takes you to the coffee when pressed, and fades away
// once you start scrolling.
(() => {
  const hero = document.querySelector("main > .hero-wrapper .webgl-bean-01");
  if (!hero) return;
  const still = matchMedia("(prefers-reduced-motion: reduce)");
  const cue = document.createElement("button");
  cue.type = "button";
  cue.className = "okt-scrollcue";
  cue.setAttribute("aria-label", "Scroll down to the coffee");
  cue.innerHTML = '<span class="okt-scrollcue__word">scroll</span> <span class="okt-scrollcue__arrow">↓</span>';
  cue.addEventListener("click", () => {
    const next = hero.closest(".hero-wrapper")?.nextElementSibling;
    const behavior = still.matches ? "auto" : "smooth";
    if (next) next.scrollIntoView({ behavior, block: "start" });
    else scrollBy({ top: innerHeight, behavior });
  });
  hero.append(cue);
  let queued = false;
  const update = () => { queued = false; cue.classList.toggle("is-gone", scrollY > 40); };
  addEventListener("scroll", () => { if (!queued) { queued = true; requestAnimationFrame(update); } }, { passive: true });
  update();
})();

// Product pages: the same title bar across the top, so the product starts below the header
// rather than underneath it. The bar's top padding covers however much the header overlaps.
(() => {
  const section = document.querySelector("main > .shopify-section:has(.product-information)");
  if (!section) return;
  let onScreen = true;
  const bar = oktTitleBar(() => onScreen, { home: true });
  bar.classList.add("okt-bar--page");
  section.prepend(bar);
  const header = document.querySelector("#header-group");
  const fit = () => {
    const overlap = header ? header.getBoundingClientRect().bottom - (section.getBoundingClientRect().top + scrollY) : 0;
    bar.style.setProperty("--okt-overlap", `${Math.max(0, Math.round(overlap))}px`);
  };
  fit();
  addEventListener("resize", fit);
  try { new IntersectionObserver(([e]) => { onScreen = e.isIntersecting; }).observe(bar); } catch {}
})();

// "checkout →" under the add to cart button (blocks/buy-buttons.liquid): Liquid hides it while the
// cart is empty; this shows it the moment something goes in, and hides it again if the cart empties.
document.addEventListener("cart:update", (e) => {
  const { resource, data = {} } = e.detail || {};
  if (data.didError) return;
  const count = resource?.item_count ?? (data.source === "product-form-component" ? 1 : data.itemCount ?? 0);
  document.querySelectorAll("[data-okt-checkout]").forEach((a) => { a.hidden = count === 0; });
});

// For people who open the developer console (the HTML comment at the top of theme.liquid is the
// view-source version).
console.log(
  "%c☕ good artists copy, great artists steal.%c\nsome brew it gooder, some do it gooder\nand some are running in a race that never has a finish line.\n\nhappy pastings.",
  "font: 700 14px monospace; color: #e3a857;",
  "font: 12px monospace; color: inherit;"
);
